/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    StationType,
    StationTypeFromJSON,
    StationTypeFromJSONTyped,
    StationTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface StationsControllerConfiguration
 */
export interface StationsControllerConfiguration {
    /**
     * 
     * @type {Array<StationType>}
     * @memberof StationsControllerConfiguration
     */
    readonly stationTypes?: Array<StationType> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof StationsControllerConfiguration
     */
    readonly timeZones?: Array<string> | null;
}

export function StationsControllerConfigurationFromJSON(json: any): StationsControllerConfiguration {
    return StationsControllerConfigurationFromJSONTyped(json, false);
}

export function StationsControllerConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): StationsControllerConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stationTypes': !exists(json, 'stationTypes') ? undefined : (json['stationTypes'] === null ? null : (json['stationTypes'] as Array<any>).map(StationTypeFromJSON)),
        'timeZones': !exists(json, 'timeZones') ? undefined : json['timeZones'],
    };
}

export function StationsControllerConfigurationToJSON(value?: StationsControllerConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}


